export default __webpack_public_path__ + "static/foton-4da42aa2b50c403ebd18689fb585b352.png";